import styled from "styled-components"

export const FieldContainer = styled.div `

    display: grid;
    width: 250px;
    margin: 0;

`